import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  offerList: [],
  loading: false,
  error: null,
};

const GetAllOfferSlice = createSlice({
  name: "GetAllOffer",
  initialState,
  reducers: {
    fetchOffersStart: (state) => {
      state.loading = true;
      state.error = null;
    },

    fetchOffersSuccess: (state, action) => {
      state.loading = false;
      state.offerList = action.payload;
    },

    fetchOffersFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchOffersStart,
  fetchOffersSuccess,
  fetchOffersFailure,
} = GetAllOfferSlice.actions;

export default GetAllOfferSlice.reducer;